module.exports = __webpack_public_path__ + "static/media/Xicon.1a121fd7.svg";